<div class="d-flex align-items-center gap-4">
  <div *ngIf="row.cardText" class="detail-label flex-grow-1" i18n>{{ row.cardText }}</div>
  <div *ngIf="!row.cardText" class="flex-grow-1"></div>
  <div class="d-flex flex-column align-items-end gap-1">
    <div class="detail-value" i18n>{{ row.paymentAmount | currency }} {{ frequencyLabel }}</div>
    <div class="detail-sub-value" i18n>{{ row.useMinimumAmount ? 'Minimum' : 'Custom' }}</div>
  </div>
</div>
